/* eslint-disable react/prop-types */

import React from 'react';
import TableResults from './TableResults';
import MosaicResults from './MosaicResults';
import DefaultResults from './DefaultResults';

export default function SearchResults(props) {
  if (props.mode === 'Tekstinäkymä' || props.mode === 'textView') {
    return <TableResults {...props} />;
  }
  else if (props.mode === 'Kuvamosaiikki' || props.mode === 'pictureMosaic') {
    return <MosaicResults {...props} />;
  }
  
  return <DefaultResults {...props} />;
}